<template>
  <div>
    <!--====== PRELOADER PART START ======-->

    <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>
        <div class="layer layer-three"><span class="overlay"></span></div>
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->
    <sidebar-home-one :sidebar="sidebar" :side="title" @toggleSidebar="toggleSidebar"  :menuItems="navs" />
    <!--====== OFFCANVAS MENU PART ENDS ======-->

    <!--====== APPIE HEADER PART START ======-->

    <header-home-two @toggleSidebar="toggleSidebar" :menuItems="navs"/>

    <!--====== APPIE HEADER PART ENDS ======-->

    <!--====== APPIE HERO PART START ======-->

    <!--    <hero-home-two offer_title="12 day free" heading="Ready to launch your app in one," more_heading="Application" description="Find the best application in the appie." :hero_img="hero_img"/>-->

    <!--====== APPIE HERO PART ENDS ======-->

    <!--====== APPIE SERRVICE 2 PART START ======-->

    <!--    <services-home-two title="How does it work" description="The full monty spiffing good time no biggie cack grub fantastic."/>-->
    <!--====== APPIE SERRVICE 2 PART ENDS ======-->

    <!--====== APPIE ABOUT PART START ======-->

    <!--    <about-home-two title="Make a lasting impression with appie." description="Jolly good quaint james bond victoria sponge happy days cras arse over blatant." />-->

    <!--====== APPIE ABOUT PART ENDS ======-->

    <!--====== APPIE FEATURES 2 PART START ======-->

    <!--    <feature-home-two title="Wherever you need-->
    <!--" more_title="us the most" description="The full monty spiffing good time no biggie cack grub fantastic."/>-->

    <!--====== APPIE FEATURES 2 PART ENDS ======-->

    <!--====== APPIE COUNTER PART START ======-->

    <!--    <counter-home-two title="How does it work" description="The full monty spiffing good time no biggie cack grub fantastic."/>-->

    <!--====== APPIE COUNTER PART ENDS ======-->

    <!--====== APPIE VIDEO PLAYER PART START ======-->

    <!--    <video-play-home-two title="Watch the two-minute video to learn how." description="The wireless cheesed on your bike mate zonked a load of old tosh hunky dory it's all gone to pot haggle william car boot pear shaped geeza." videoUrl="//www.youtube.com/embed/EE7NqzhMDms?autoplay=1" :thumbnail="video_bg_thumb"/>-->

    <!--====== APPIE VIDEO PLAYER PART ENDS ======-->

    <!--====== APPIE DOWNLOAD PART START ======-->
    <!--    <download-home-two title="App is available" more_title="for free on app store" description="Jolly good quaint james bond victoria sponge happy days cras arse over blatant."/>-->
    <!--====== APPIE DOWNLOAD PART ENDS ======-->

    <!--====== APPIE PRICING 2 PART START ======-->

    <!--    <priceing-home-two title="Simple pricing for Everyone" description="The full monty spiffing good time no biggie cack grub fantastic."/>-->

    <!--====== APPIE PRICING 2 PART ENDS ======-->

    <!--====== APPIE TESTIMONIAL 2 PART START ======-->

    <!--    <testimonial-home-two/>-->

    <section class="appie-testimonial-2-area mt-120 mb-90" id="testimonial">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
<!--            <center><span v-html="title" :style="{textSizeAdjust:textSize}"></span></center>-->
            <center>
<!--            <span class="badge rounded-pill " style="background-color: red;"><span v-html="countView.title" :style="{backgroundColor:bgColor}"></span></span>-->
            </center>
            <br>
            <div class="row">
{{title}}
<!--              <div v-if="list.length > 0">-->
<!--                <div class="col-12 col-sm-12 col-lg-6 mb-20 temp_10_space" v-for="(ListData,index) in list" :key="index">-->
<!--                  <div class="card" style="width: 100%">-->
<!--                    <div class="card-body">-->
<!--                      <div v-for="(ListTitleData,index) in ListData.title" :key="index">-->

<!--                        <center>-->
<!--                          <span v-if="ListTitleData.visible === '1'" class="badge rounded-pill bg-secondary" v-html="ListTitleData.title"></span>-->
<!--                          <span v-if="ListData.active === '1'" style="color: green;float: inline-end;">✔</span>-->
<!--                          <span v-else style="color: red;float: inline-end;">X</span>-->
<!--                        </center>-->
<!--                      </div>-->

<!--                      <br>-->
<!--                      <div class="container">-->
<!--                        <table style="width: 100%">-->
<!--                          &lt;!&ndash;                      <div >&ndash;&gt;-->
<!--                          <tr v-for="(SubListData,index) in ListData.list" :key="index">-->
<!--                            <th v-html="SubListData.title" :style="{color:SubListData.bgColor}"></th>-->
<!--                            <td v-html="SubListData.content" ></td>-->
<!--                          </tr>-->

<!--                          &lt;!&ndash;                      </div>&ndash;&gt;-->
<!--                        </table>-->
<!--                        <br>-->
<!--                        <div class="row">-->
<!--                          <div class="col-6 col-lg-6 col-md-6">-->
<!--                            <span v-html="ListData.card[0].title"></span>-->
<!--                          </div>-->
<!--                          <div class="col-6 col-lg-6 col-md-6">-->
<!--                            <span v-html="ListData.card[1].title"></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <br>-->
<!--                      <div v-for="(ListButtonData,index) in ListData.button" :key="index">-->
<!--                        &lt;!&ndash;                      {{ListButtonData}}&ndash;&gt;-->
<!--                        <center>-->
<!--                          <a :href="ListData.invoice_pdf">-->
<!--                            <button type="button" class="btn" :style="{backgroundColor:ListButtonData.bgColor}" v-html="ListButtonData.title"></button>-->
<!--                          </a>-->
<!--                        </center>-->

<!--                      </div>-->



<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                <div class="card">-->
<!--                  <div class="card-body">-->
<!--                   <center>-->
<!--                     <h5><span style="color: blue">Data Not</span> <span style="color: red;">Found!</span></h5><br>-->
<!--                     <span style="color: black;font-weight: 800;">நீங்கள் தேடிய தகவல் தற்போது இல்லை</span>-->
<!--                     <br>-->
<!--                     <br>-->
<!--                     <button type="button" @click="navigateToSamePage" class="btn btn-success">Exit</button>-->
<!--                   </center>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

            </div>

          </div>
        </div>
      </div>
    </section>



    <!--====== APPIE TESTIMONIAL 2 PART ENDS ======-->

    <!--====== APPIE SPONSER PART START ======-->

    <!--    <sponser-home-two title="Appie works best with" more_title="your favorite platforms" description="Join over 40,000 businesses worldwide."/>-->

    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->

    <!--    <footer-home-two/>-->


    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
import SidebarHomeOne from '../HomePage/SidebarHomeOne.vue'
// import AboutHomeTwo from './AboutHomeTwo.vue'
// import CounterHomeTwo from './CounterHomeTwo.vue'
// import DownloadHomeTwo from './DownloadHomeTwo.vue'
// import FeatureHomeTwo from './FeatureHomeTwo.vue'
// import FooterHomeTwo from './FooterHomeTwo.vue'
import HeaderHomeTwo from './Header.vue'
// import HeroHomeTwo from './HeroHomeTwo.vue'
// import PriceingHomeTwo from './PriceingHomeTwo.vue'
// import ServicesHomeTwo from './ServicesHomeTwo.vue'
// import SponserHomeTwo from './SponserHomeTwo.vue'
// import TestimonialHomeTwo from './TestimonialHomeTwo.vue'
// import VideoPlayHomeTwo from './VideoPlayHomeTwo.vue'
import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
export default {
  props:{
    section_heading:{
      type: String,
    },
    more_heading:{
      type:String
    },
    description:{
      type:String
    },
    grid_items:{
      type:Array,
    }
  },
  components: {
    HeaderHomeTwo,
    // HeroHomeTwo,
    // ServicesHomeTwo,
    // AboutHomeTwo,
    // FeatureHomeTwo,
    // CounterHomeTwo,
    // CounterHomeTwo,
    // VideoPlayHomeTwo,
    // DownloadHomeTwo,
    // PriceingHomeTwo,
    // TestimonialHomeTwo,
    // SponserHomeTwo,
    // FooterHomeTwo,
    SidebarHomeOne, },
  data(){
    return{
      title:'',
      textSize:'',
      countView:[],
      list:[],
      ListTitleData:[],
      ListButtonData:[],
      bgColor:'',
      template:'',
      urlData:'',
      ViewPosttitle:'',
      sidebar:false,
      navs:[
        {
          name:'Profile',
          childrens:[
            {
              // name:'Home 1',
              name:'Update KYC',
              path:'/'
            },
            {
              // name:'Home 2',
              name:'Update Profile',
              path:'/home-two'
            },
            {
              // name:'Home 3',
              name:'View Profile',
              path:'/home-three'
            },
            {
              // name:'Home 4',
              name:'Viewed Profiles',
              path:'/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name:'Change Mobile Number',
            //   path:'/home-five'
            // },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name:'Customer Care',
          path:'/contact'
        },
        {
          // name:'contact',
          name:'Notification',
          path:'/contact'
        }
      ],
      hero_img:hero_img,
      video_bg_thumb:video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {

    this.encryptedParam = this.$route.query.page;

    this.decryptedValue = this.Decrypt(this.encryptedParam);
    this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    console.log(this.modifiedString)
    try {
      const PaymentHistoryData = await callAxiosWithConfig('https://jobspro.nithrajobs.com/api/' + this.modifiedString, '', 'post');
      console.log(PaymentHistoryData);
      // console.log(PaymentHistoryData.title);
      this.title = PaymentHistoryData;
      // this.title = PaymentHistoryData.title;
      this.countView = PaymentHistoryData.countView;
      this.list = PaymentHistoryData.list;
      // this.template = otpdata.template;
      // console.log(this.template)
      // const inputString = otpdata;
      // this.$emit("tempData", this.title);

    } catch (error) {
      console.error('Error in Axios request:', error);
    }

  },

  methods:{

    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function(char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom(){
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight ) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar(){
      this.sidebar = !this.sidebar
    },
  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10{
    min-height: 100px;
    border:unset;
    width: 100%;
    border-radius:10px;
  }
  .temp_10_space{
    margin-bottom: 30px;
  }
  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width : 600px) and (max-width: 767px) {

}

@media (min-width : 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10{
    border:unset;
    width: 100%;
    min-height:200px;
    border-radius:10px;

  }
  .text_space{
    margin-top: 10px;
  }
  .imageSize {
    width: 4%;
  }
}

</style>
